import { components, operations } from '@/schema'

// Bank Transaction Types
export type GetDepositTransactionsParams =
	operations['BankTransactionController_getDepositTransactions']['parameters']['query']

export type GetWithdrawalTransactionsParams =
	operations['BankTransactionController_getWithdrawalTransactions']['parameters']['query']

export type DepositTransactionResponse =
	components['schemas']['PaginatedDepositTransactionsResponse']
export type WithdrawTransactionResponse =
	components['schemas']['PaginatedWithdrawTransactionsResponse']

export type ForceCompleteDepositRequest =
	components['schemas']['ForceCompleteDepositDto']

export type CreateManualDepositTransactionRequest =
	components['schemas']['CreateManualDepositTransactionDto']

export type CreateManualWithdrawTransactionRequest =
	components['schemas']['CreateWithdrawTransactionDto']

export type CreateWithdrawTransactionRequest =
	components['schemas']['CreateWithdrawTransactionDto']

export type ForceCompleteWithdrawRequest =
	components['schemas']['ForceCompleteWithdrawDto']

export type AdminApproveWithdrawRequest =
	components['schemas']['AdminApproveWithdrawDto']

export type CancelWithdrawTransactionRequest =
	components['schemas']['CancelWithdrawTransactionDto']

export type RefundWithdrawTransactionRequest = {
	note?: string
}

export type ForceCancelDepositTransactionRequest =
	components['schemas']['ForceCancelDepositTransactionDto']

export type GetDepositTransactionsByIdResponse =
	components['schemas']['AdminDepositTransactionResponse']

export type GetWithdrawalTransactionsByIdResponse =
	components['schemas']['AdminWithdrawTransactionResponse']

// Payment Gateway Error Types
export type PaymentGatewayErrorResponse =
	components['schemas']['PaymentGatewayErrorResponse']

// True Wallet Logs Types
export type TrueWalletTransactionLogResponse =
	components['schemas']['TrueWalletTransactionLogResponse']

export type PaginatedTrueWalletTransactionLogsResponse =
	components['schemas']['PaginatedTrueWalletTransactionLogsResponse']

export type GetTrueWalletLogsParams =
	operations['BankTransactionController_getTrueWalletTransactionLogs']['parameters']['query']

// SMS Auto Logs Types
export enum SmsAutoLogStatus {
	UNMATCHED = 'UNMATCHED',
	PROCESSING = 'PROCESSING',
	REMATCHED = 'REMATCHED',
	CANCELLED = 'CANCELLED',
	AUTO_MATCHED = 'AUTO_MATCHED',
}

export type SmsAutoTransactionLogResponse = {
	id: string
	paymentGatewayId: string
	paymentGateway: {
		id: string
		displayName: string
		bankProviderName: string
		paymentGatewayProviderName: string
		minDepositAmount?: number | null
	}
	method: string
	amount: number
	accountNumber: string
	status: SmsAutoLogStatus
	message: string | null
	depositTransactionId: string | null
	depositTransaction?: { txId: string } | null
	matchedAt: string | null
	note: string | null
	rematchedBy: string | null
	previousAmount?: number | null
	amountChangeLog?: Array<{
		from: number
		to: number
		depositAmount?: number | null
		depositTransactionId?: string | null
		changedBy: string
		changedAt: string
		reason?: string | null
	}> | null
	createdAt: string
	updatedAt: string
}

export type PaginatedSmsAutoTransactionLogsResponse = {
	data: SmsAutoTransactionLogResponse[]
	total: number
	skip: number
	take: number
}

export type GetSmsAutoLogsParams = {
	paymentGatewayId?: string
	accountNumber?: string
	amount?: number
	startDate?: string
	endDate?: string
	status?: SmsAutoLogStatus[]
	skip?: number
	take?: number
	sortByCreatedAt?: string
}

export type RematchSmsAutoLogRequest = {
	depositTransactionId: string
	newAmount?: number
	note?: string
}

export type CancelSmsAutoLogRequest = {
	note: string
}

export type SearchUsersForRematchParams = {
	smsLogId: string
	accountNumber?: string
	bankProviderName?: string
}

export type SearchUsersForRematchResultItem = {
	playerId: string
	maskedPhone: string
	accountNumber: string
	accountName: string
	bankProvider: string
	pendingDepositCount: number
}

export type SearchUsersForRematchResponse = {
	data: SearchUsersForRematchResultItem[]
	total: number
}

// TrueMoney Deposits Types
export type TrueMoneyDepositsResponse =
	components['schemas']['TrueMoneyDepositsResponse']

export type GetTrueMoneyDepositsParams =
	operations['BankTransactionController_getTrueMoneyDeposits']['parameters']['query']

// Transaction Statistics Types
export type TransactionStatisticsResponse =
	components['schemas']['TransactionStatisticsResponse']

export type DepositStatistics = components['schemas']['DepositStatistics']
export type WithdrawStatistics = components['schemas']['WithdrawStatistics']
export type TransactionMethodStatistics =
	components['schemas']['TransactionMethodStatistics']

export type GetTransactionStatisticsParams = {
	startDate?: string
	endDate?: string
}
